import styles from "./template-list-modal.module.css";
import { useTemplateStore } from "entity-store/template-store/use-template-store";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { useAccount } from "BEDROCK/account/use-account";
import { ProjectPreview } from "components/common/project-preview";
import { Modal } from "BEDROCK/shared-components/modal";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { ListItem, ListItemAction } from "admin/shared-components/list-item";

interface TemplateListModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedTemplates: ProjectTemplate[];
  onSelectTemplate: (template: ProjectTemplate) => void;
}

export const TemplateListModal = (props: TemplateListModalProps) => {
  const { templates, isLoading, isError } = useTemplateStore();

  const onSelectTemplate = (template: ProjectTemplate) => {
    props.onSelectTemplate(template);
  };

  return (
    <Modal
      isOpen={props.isOpen}
      showCloseButton={false}
      onClose={() => {
        props.onClose();
        // paths.navigateTo(paths.admin);
      }}
    >
      <div className={styles.container}>
        <div className={styles.toolbar}>
          <ListControls onClickDone={props.onClose} />
        </div>
        <List
          templates={templates ?? []}
          selectedTemplates={props.selectedTemplates}
          onClick={(template) => {
            onSelectTemplate(template);
          }}
        />
      </div>
    </Modal>
  );
};

interface ListControlsProps {
  //   onClickAddTemplate: () => void;
  onClickDone: () => void;
}
const ListControls = (props: ListControlsProps) => {
  return (
    <div className={styles.listControls}>
      <div></div>
      <CTAButton variant="SECONDARY" onClick={props.onClickDone}>
        DONE
      </CTAButton>
    </div>
  );
};

interface ListProps {
  templates: ProjectTemplate[];
  selectedTemplates: ProjectTemplate[];
  onClick: (project: ProjectTemplate) => void;
}
const List = (props: ListProps) => {
  return (
    <div className={styles.list}>
      {props.templates.map((t) => (
        <Item
          key={t.id}
          template={t}
          isSelected={props.selectedTemplates.some(
            (selected) => selected.id === t.id
          )}
          onClick={() => {
            props.onClick(t);
          }}
        />
      ))}
    </div>
  );
};

interface ItemProps {
  template: ProjectTemplate;
  isSelected: boolean;
  onClick: () => void;
}
const Item = (props: ItemProps) => {
  const { account } = useAccount();

  const preview = (
    <ProjectPreview
      template={props.template}
      size={{ width: 140, height: 140 }}
    />
  );

  const iconAction: ListItemAction = {
    iconName: props.isSelected ? "CHECK" : "CHECK-UNCHECKED",
    onClick: () => {
      props.onClick();
    },
  };

  return (
    <button onClick={props.onClick}>
      <ListItem
        preview={preview}
        title={props.template.name}
        description={
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam sed ante vitae nulla cursus eleifend non quis arcu. Fusce ultrices faucibus eros non gravida. Vivamus mi erat, commodo id vestibulum at"
        }
        trailingIconActions={[iconAction]}
      />
    </button>
  );
};
